/* src/app/front-layout/calendar/year-ten-mocktest/year-ten-mocktest.component.css */
.hero-section {
  background:
    linear-gradient(
      135deg,
      #0077b6 0%,
      #005a8c 100%);
  padding: auto;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hero-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(
      circle at 20% 50%,
      rgba(255, 200, 59, 0.1) 0%,
      transparent 50%),
    radial-gradient(
      circle at 80% 80%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 50%);
  pointer-events: none;
}
.hero-container {
  max-width: 1400px;
  margin: 80px auto;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.announcement-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #FFC83B;
  color: #000;
  padding: 10px 24px;
  border-radius: 5px;
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 10px;
  box-shadow: 0 4px 20px rgba(255, 200, 59, 0.3);
  animation: slideDown 0.6s ease-out;
  text-align: center;
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.hero-title {
  font-size: 54px;
  font-weight: 900;
  color: white;
  line-height: 1.1;
  margin-bottom: 20px;
  animation: fadeInUp 0.8s ease-out 0.2s both;
  text-align: center;
}
.hero-title span {
  display: block;
  background:
    linear-gradient(
      90deg,
      #FFC83B,
      #FFE066);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 45px;
}
.exam-boards {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  margin: 10px 0;
  animation: fadeInUp 0.8s ease-out 0.4s both;
}
.board-badge {
  background: rgba(255, 255, 255, 0.15);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 12px 24px;
  border-radius: 5px;
  font-weight: 600;
  font-size: 15px;
  transition: all 0.3s ease;
}
.board-badge:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}
.delivery-modes-hero {
  display: flex;
  gap: 12px;
  margin: 20px 0 20px;
  flex-wrap: wrap;
  animation: fadeInUp 0.8s ease-out 0.6s both;
}
.mode-pill {
  background: rgba(255, 200, 59, 0.2);
  border: 2px solid #FFC83B;
  color: #FFC83B;
  padding: 10px 20px;
  border-radius: 5px;
  font-weight: 600;
  font-size: 14px;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.cta-buttons {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  margin-top: 25px;
  margin-bottom: 30px;
  animation: fadeInUp 0.8s ease-out 0.8s both;
}
.btn-primary {
  background: #FFC83B;
  color: #000;
  padding: 16px 40px;
  border-radius: 50px;
  font-weight: 700;
  font-size: 16px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 8px 25px rgba(255, 200, 59, 0.3);
}
.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 35px rgba(255, 200, 59, 0.4);
}
.btn-secondary {
  background: transparent;
  color: white;
  padding: 16px 40px;
  border-radius: 50px;
  font-weight: 700;
  font-size: 16px;
  border: 2px solid white;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
}
.btn-secondary:hover {
  background: white;
  color: #0077b6;
  transform: translateY(-3px);
}
.offers-banner {
  background:
    linear-gradient(
      135deg,
      #fff7e0,
      #FFE8B3);
  border: 2px dashed #FFC83B;
  border-radius: 20px;
  padding: 20px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  animation: fadeInUp 0.8s ease-out 1s both;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
}
.offers-text {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.offers-text strong {
  color: #0077b6;
  font-size: 18px;
}
.btn-offer {
  background: #0077b6;
  color: white;
  padding: 12px 28px;
  border-radius: 25px;
  font-weight: 700;
  font-size: 15px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 119, 182, 0.3);
}
.btn-offer:hover {
  background: #005a8c;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 119, 182, 0.4);
}
.categories-section {
  padding: 80px 20px;
  background: #fcfcfc;
}
.section-header {
  text-align: center;
  margin-bottom: 60px;
}
.section-title {
  font-size: 48px;
  font-weight: 800;
  color: #0077b6;
  margin-bottom: 15px;
}
.section-subtitle {
  font-size: 18px;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}
.test-card {
  background: white;
  border-radius: 20px;
  padding: 0;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 119, 182, 0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(0, 119, 182, 0.1);
}
.test-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(0, 119, 182, 0.15);
}
.card-header {
  background:
    linear-gradient(
      135deg,
      #0077b6,
      #005a8c);
  padding: 30px;
  color: white;
  position: relative;
  overflow: hidden;
}
.card-header::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -20%;
  width: 200px;
  height: 200px;
  background:
    radial-gradient(
      circle,
      rgba(255, 200, 59, 0.2),
      transparent);
  border-radius: 50%;
}
.card-title {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 10px;
  position: relative;
  color: white;
}
.card-type {
  display: inline-block;
  background: rgba(255, 200, 59, 0.2);
  color: #FFC83B;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
  position: relative;
}
.card-body {
  padding: 30px;
}
.info-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;
}
.info-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.info-icon {
  width: 40px;
  height: 40px;
  background:
    linear-gradient(
      135deg,
      #e8f4f8,
      #d0ebf5);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.info-content {
  flex: 1;
}
.info-label {
  font-size: 13px;
  font-weight: 600;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
}
.info-value {
  font-size: 15px;
  font-weight: 600;
  color: #333;
}
.mode-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;
}
.tag {
  background: #e8f4f8;
  color: #0077b6;
  padding: 6px 14px;
  border-radius: 15px;
  font-size: 13px;
  font-weight: 600;
}
.card-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.action-btn {
  padding: 14px 24px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
}
.action-primary {
  background: #0077b6;
  color: white;
}
.action-primary:hover {
  background: #005a8c;
  transform: scale(1.02);
}
.action-outline {
  background: white;
  color: #0077b6;
  border: 2px solid #0077b6;
}
.action-outline:hover {
  background: #0077b6;
  color: white;
}
.centers-section {
  padding: 80px 20px;
  background:
    linear-gradient(
      180deg,
      #fcfcfc 0%,
      #f5f5f5 100%);
  display: none;
}
.centers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
  max-width: 1400px;
  margin: 0 auto;
}
.center-card {
  background:
    linear-gradient(
      135deg,
      #0077b6,
      #005a8c);
  border-radius: 16px;
  padding: 30px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 8px 25px rgba(0, 119, 182, 0.2);
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.center-card::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -30%;
  width: 200px;
  height: 200px;
  background:
    radial-gradient(
      circle,
      rgba(255, 200, 59, 0.15),
      transparent);
  border-radius: 50%;
  transition: all 0.5s ease;
}
.center-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 15px 40px rgba(0, 119, 182, 0.3);
}
.center-card:hover::before {
  transform: scale(1.5);
}
.center-name {
  font-size: 22px;
  font-weight: 800;
  color: white;
  margin-bottom: 12px;
  position: relative;
}
.center-exams {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
  position: relative;
}
.hero-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  max-width: 900px;
  margin: 30px auto 0;
  text-align: center;
  animation: fadeInUp 0.8s ease-out 1.6s both;
}
.centers-in-hero {
  width: 100%;
  margin: 40px 0 20px;
  animation: fadeInUp 0.8s ease-out 1.2s both;
}
.centers-grid-hero {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
  max-width: 1400px;
  margin: 0 auto;
}
.center-card-hero {
  background: rgba(255, 255, 255, 0.15);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  padding: 25px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.center-card-hero::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -30%;
  width: 150px;
  height: 150px;
  background:
    radial-gradient(
      circle,
      rgba(255, 200, 59, 0.2),
      transparent);
  border-radius: 50%;
  transition: all 0.5s ease;
}
.center-card-hero:hover {
  transform: translateY(-8px);
  background: rgba(255, 255, 255, 0.25);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
}
.center-card-hero:hover::before {
  transform: scale(1.5);
  opacity: 0.8;
}
.center-name-hero {
  font-size: 20px;
  font-weight: 700;
  color: white;
  margin-bottom: 10px;
  position: relative;
}
.center-exams-hero {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.5;
  position: relative;
}
@media (max-width: 768px) {
  .hero-title {
    font-size: 42px;
  }
  .hero-title span {
    font-size: 25px;
  }
  .section-title {
    font-size: 36px;
  }
  .cards-grid {
    grid-template-columns: 1fr;
  }
  .centers-grid-hero {
    grid-template-columns: 1fr;
  }
  .cta-buttons {
    flex-direction: column;
  }
  .btn-primary,
  .btn-secondary {
    width: 100%;
    justify-content: center;
  }
  .offers-banner {
    flex-direction: column;
    text-align: center;
  }
}
.icon {
  width: 20px;
  height: 20px;
}
.cal-inst {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.cal-inst h3 {
  font-weight: bold;
}
.cal-inst p {
  font-size: 24px;
}
.reset-btn {
  width: 250px;
  background-color: #007BA7;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 8px 18px;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.reset-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(253, 241, 13, 0.4);
}
.mtc-title {
  font-weight: 800;
  text-align: center;
  margin: 8px 0 24px;
  color: #0f172a;
  font-size: 32px;
}
.mock-calendar {
  --toolbar: #FFBF00;
  --toolbar-dark: #007BA7;
  --online: #fb923c;
  --ff: #007BA7;
  --book: #FFBF00;
  --book-dark: #007BA7;
  --card-border: #dbeafe;
  --card-hover: #1d4ed8;
}
.mock-calendar .toolbar {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--toolbar);
  padding: 20px;
  border-radius: 12px;
  margin: 0 8px 24px;
}
.search-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  width: 50%;
}
.mock-calendar .search-input {
  border: none;
  background: #fff;
  border-radius: 999px;
  padding: 10px 14px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, .08) inset;
  font-weight: 600;
  width: 100%;
}
.flt-text {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px;
}
.mock-calendar .toolbar .toolbar-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}
.mock-calendar .toolbar .toolbar-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 140px;
}
.mock-calendar .toolbar .toolbar-item label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .03em;
  color: #333;
  margin: 0;
  text-align: center;
}
.mock-calendar .toolbar .dropdown-like {
  width: 250px;
  position: relative;
}
.mock-calendar .toolbar .dropdown-like .form-select,
.mock-calendar .toolbar .dropdown-like select {
  appearance: none;
  border: none;
  background: #fff;
  border-radius: 20px;
  padding: 8px 28px 8px 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .1);
  font-weight: 600;
  font-size: 13px;
  width: 100%;
  cursor: pointer;
}
.mock-calendar .toolbar .dropdown-like .chev {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  pointer-events: none;
  color: #666;
}
.list-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mock-calendar .session-card {
  width: 80%;
  background: #fff;
  border-radius: 12px;
  padding: 16px 20px;
  margin-top: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: auto 1fr auto auto auto;
  align-items: center;
  gap: 16px;
  transition: all 0.2s ease;
}
.mock-calendar .list-body .session-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}
.mock-calendar .list-body .session-card .date-chip {
  background: #0a84ae;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 800;
  font-size: 14px;
  white-space: nowrap;
  min-width: 100px;
  text-align: center;
}
.mock-calendar .list-body .session-card .date-chip.range {
  background: #f59e0b;
}
.mock-calendar .list-body .session-card .date-chip span {
  color: inherit;
  background: none;
  padding: 0;
  border-radius: 0;
  font-weight: inherit;
}
.mock-calendar .list-body .session-card .session-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.mock-calendar .list-body .session-card .session-title {
  font-weight: 700;
  color: #1e40af;
  text-decoration: none;
  font-size: 16px;
}
.mock-calendar .list-body .session-card .session-subtitle {
  font-weight: 600;
  color: #374151;
  font-size: 14px;
  text-decoration: none;
}
.mock-calendar .list-body .session-card .session-pattern {
  font-size: 18px;
  font-weight: 600;
  color: #6b7280;
}
.mock-calendar .list-body .session-card .badges {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.mock-calendar .list-body .session-card .badges .badge {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 16px;
  color: #fff;
}
.mock-calendar .list-body .session-card .badges .badge-online {
  background: var(--online);
}
.mock-calendar .list-body .session-card .badges .badge-ff {
  background: var(--ff);
}
.mock-calendar .list-body .session-card .badges .location-badge {
  background: #007BA7;
  color: #ffffff;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}
.mock-calendar .list-body .session-card .badges .location-badge img {
  width: 14px;
  height: 14px;
}
.mock-calendar .list-body .session-card .badges .location-badge .truncate {
  max-width: 120px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mock-calendar .list-body .session-card .price {
  font-weight: 800;
  font-size: 16px;
  color: #0f172a;
  min-width: 80px;
  align-self: center;
}
.mock-calendar .list-body .session-card .action .btn-book,
.mock-calendar .btn-book {
  width: 200px;
  background: var(--book);
  color: #020202;
  border-radius: 20px;
  padding: 10px 24px;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  transition: background 0.2s ease;
  min-width: 80px;
  border: none;
  cursor: pointer;
}
.mock-calendar .btn-book:hover {
  background: var(--book-dark);
}
.mock-calendar .btn-load {
  background: var(--toolbar-dark);
  color: #111827;
  border-radius: 20px;
  padding: 12px 24px;
  font-weight: 800;
  border: none;
  cursor: pointer;
  font-size: 14px;
}
.mock-calendar .btn-load:hover {
  background: #d69e00;
}
.location-badge {
  background: #007BA7;
}
.hidden {
  display: none;
}
@media (max-width: 991.98px) {
  .mock-calendar .toolbar .toolbar-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  .mock-calendar .toolbar .toolbar-item {
    min-width: 200px;
  }
  .mock-calendar .list-body .session-card {
    grid-template-columns: 1fr;
    gap: 12px;
    text-align: center;
  }
  .mock-calendar .list-body .session-card .session-info {
    align-items: center;
  }
  .mock-calendar .list-body .session-card .badges {
    justify-content: center;
  }
}
@media (max-width: 575.98px) {
  .mock-calendar .toolbar .toolbar-row {
    grid-template-columns: 1fr;
  }
}
.af-ts {
  display: flex;
  justify-content: center;
  align-items: center;
}
.af-ts h4 {
  text-align: center;
  margin-right: 25px;
  margin-left: 25px;
  margin-top: 80px;
}
.ft-sc {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  background-color: #fafafa;
  align-items: center;
}
.ft-sc-title {
  font-weight: 600;
  margin: 35px;
  color: rgb(74, 74, 74);
  font-size: 42px;
}
.ft-sc-info {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.ft-sc-item {
  width: 350px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 16px;
  padding: 20px;
  justify-content: center;
  align-items: flex-start;
  margin-top: 50px;
  margin-bottom: 50px;
}
.ft-sc-item img {
  width: 75px;
}
.left {
  margin-left: 100px;
}
.right {
  margin-right: 100px;
}
.ft-sc-item h5 {
  color: #ED6823;
  font-size: 20px;
  line-height: 20px;
}
.ft-sc p {
  font-size: 18px;
}
.co-sc {
  display: flex;
  flex-direction: column;
  background-color: #E6E6E6;
  align-items: center;
}
.co-sc-title {
  font-size: 36px;
  margin-top: 80px;
  text-align: center;
}
.co-sc-title span {
  color: #f2985d;
  font-weight: bold;
}
.card-ts {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 22px;
  width: 380px;
  height: 250px;
  background-color: white;
  margin-top: 50px;
  margin-left: 25px;
  margin-right: 25px;
  margin-bottom: 50px;
  padding: 10px;
}
.ts-sc {
  display: flex;
}
.faq-sc {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.faq-sc h1 {
  margin-top: 50px;
  font-weight: bold;
  font-size: 42px;
}
.drop-d {
  width: 50%;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid #000000;
}
details {
  border: 0.5px solid #000000;
  overflow: hidden;
  width: 100%;
}
summary {
  padding: 10px 15px;
  cursor: pointer;
  font-weight: bold;
  width: 100%;
  border-radius: 0;
  border: 0.5px solid #000000;
  list-style: none;
  font-size: 16px;
}
details[open] summary {
  background: #e0e0e0;
}
details div {
  padding: 15px;
  background: #fff;
}
summary::before {
  content: "\25bc    ";
  font-size: 14px;
  transition: transform 0.3s ease;
  margin-left: 10px;
}
details[open] summary::after {
  transform: rotate(180deg);
}
details div {
  padding: 0 15px;
  background: #fff;
  opacity: 0;
  height: 0;
  overflow: hidden;
  transform: scaleY(0);
  transform-origin: top;
  transition:
    transform 0.4s ease-in-out,
    opacity 0.3s ease-in-out,
    height 0.4s ease-in-out;
}
details[open] div {
  opacity: 1;
  height: auto;
  transform: scaleY(1);
  padding: 15px;
}
a {
  color: red;
  text-decoration: none;
}
.so-sc {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 25px;
}
.so-sc img {
  width: 30px;
  height: 30px;
}
.faq-sc h3 {
  text-align: center;
  margin-top: 50px;
}
@media (max-width: 768px) {
  .main-wrapper {
    height: auto;
    min-height: 70vh;
    align-items: center;
    background-image: url(/assets/images/gcse-mv.png);
    background-size: cover;
    background-position: center;
    background-attachment: scroll;
  }
  .nav-bar {
    width: 100%;
    border-radius: 0;
    flex-wrap: wrap;
    justify-content: center;
    padding: 10px;
    gap: 8px;
    display: none;
  }
  .nav-item {
    font-size: 16px;
    width: 100%;
    text-align: center;
  }
  .nav-button {
    padding: 8px 16px;
    font-size: 14px;
    border-radius: 15px;
  }
  .content {
    position: relative;
    width: 100%;
    border-radius: 0;
    padding: 20px 15px;
    margin-top: auto;
    margin-bottom: 20px;
  }
  .content h1 {
    font-size: 28px;
  }
  .content h2 {
    font-size: 20px;
  }
  .content p {
    font-size: 14px;
  }
  .logo3 {
    width: 100px;
    height: 50px;
  }
  .top p {
    font-size: 12px;
  }
  .cal-inst h1 {
    font-weight: bold;
    font-size: 28px;
    text-align: center;
  }
  .cal-inst h2 {
    font-size: 18px;
    text-align: center;
  }
  .nw-strp {
    gap: 10px;
    padding: 5px;
  }
  .nw-strp h5 {
    font-size: 11px;
  }
  .nw-strp-lft {
    gap: 5px;
  }
  .nw-strp-rgt {
    gap: 5px;
  }
  .bk-dm {
    padding: 5px;
    font-size: 10px;
  }
  .to-nmt {
    font-size: 10px;
    padding: 5px;
  }
  .trust-pilot img {
    width: 100px;
    height: 50px;
  }
  .hs-h1 {
    font-size: 30px;
  }
  .hero-section h1 {
    font-size: 30px;
    text-align: center;
  }
  .hero-section h2 {
    text-align: center;
    font-size: 18px;
    margin-left: 10px;
    margin-right: 10px;
    line-height: 20px;
  }
  .hero-section h3 {
    font-size: 22px;
    text-align: center;
  }
  .hero-section h4 {
    font-size: 16px;
  }
  .hs-btns {
    flex-direction: column;
  }
  .hero-section ul {
    flex-direction: column;
  }
  .stripe h3 {
    font-size: 20px;
    text-align: center;
  }
  .af-ts h1 {
    font-size: 24px;
  }
  .ft-sc {
    height: 100%;
  }
  .ft-sc-title {
    text-align: center;
    font-size: 24px !important;
  }
  .ft-sc-item img {
    margin: 5dp;
    width: 45px;
  }
  .ft-sc-item h5 {
    font-size: 18px;
  }
  .left {
    margin-left: 00px;
  }
  .right {
    margin-right: 00px;
  }
  .container {
    padding: 10px;
    height: auto;
  }
  .header2 h1 {
    font-size: 18px;
    padding-left: 10px;
  }
  .header2 h2 {
    font-size: 14px;
    display: none;
  }
  .logo-mocktest {
    width: 80px;
    height: 30px;
  }
  .tabs {
    gap: 5px;
    flex-wrap: wrap;
  }
  .tab {
    padding: 8px 12px;
    font-size: 14px;
  }
  .timetable {
    margin-top: 10px;
  }
  .test-row {
    height: auto;
    flex-direction: column;
    padding: 10px;
    border-radius: 10px;
  }
  .test-info.enhanced {
    height: auto;
    flex: none;
    margin-bottom: 10px;
    border-radius: 10px;
    padding: 10px;
    text-align: center;
  }
  .test-date {
    width: auto;
    font-size: 16px;
    margin-top: 10px;
  }
  .testName {
    font-size: 16px;
  }
  .test-centers {
    flex-direction: column;
    gap: 10px;
    margin: 10px 0;
  }
  .center {
    padding: 10px;
    border: 1px solid #ccc;
    text-align: center;
  }
  .book-btn {
    display: block;
    margin-top: 10px;
  }
  .ft-sc-info {
    flex-direction: column;
    align-items: center;
  }
  .ft-sc-item {
    width: 250px;
    height: 150px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .ft-sc-item h5 {
    font-size: 18px;
    line-height: 20px;
  }
  .ft-sc p {
    font-size: 14px;
  }
  .co-sc-title {
    margin-top: 25px;
    font-size: 22px;
  }
  .ts-sc {
    flex-direction: column;
  }
  .card-ts {
    width: 300px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .card-ts h4 {
    font-size: 16px;
  }
  .card-ts p {
    font-size: 12px;
  }
  .faq-sc h1 {
    margin-top: 25px;
    font-size: 36px;
  }
  .drop-d {
    width: 90%;
  }
  .faq-sc h3 {
    font-size: 18px;
    line-height: 25px;
  }
  .calendar-wrapper {
    width: 100%;
    margin-top: 100px;
    border-radius: 0;
    box-shadow: none;
  }
  .calendar-header {
    flex-direction: column;
    gap: 0;
  }
  .calendar-mode-buttons,
  .calendar-type-buttons {
    height: auto;
    padding: 15px 10px;
    border-radius: 0 !important;
    flex-wrap: wrap;
  }
  .calendar-month-selector {
    margin: 10px 0;
    padding: 0 10px;
    justify-content: flex-start;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .calendar-test-group {
    margin-left: 10px;
    margin-right: 10px;
  }
  .calendar-test-details {
    padding: 15px;
    flex-direction: column;
    align-items: flex-start;
  }
  .calendar-test-details h4 {
    font-size: 18px;
  }
  .calendar-test-list {
    margin: 10px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .calendar-test-card {
    width: 100%;
    padding: 12px;
  }
  .calendar-test-card h5 {
    font-size: 16px;
  }
  .mock-calendar .toolbar .toolbar-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  }
  .toolbar-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .dropdown-like {
    max-width: 150px;
  }
  .mock-calendar .list-body .session-card .session-pattern {
    font-size: 14px;
  }
  .reset-btn {
    width: 150px;
    background-color: #007BA7;
    color: white;
    border: none;
    border-radius: 30px;
    padding: 5px 10px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  .reset-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(5, 245, 25, 0.4);
  }
  .search-item {
    width: 90%;
  }
}
/*# sourceMappingURL=year-ten-mocktest.component.css.map */
